module.exports = __webpack_public_path__ + "static/img/humax-mobility.dd0db7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/humax-mobility.jpg
// module id = IreK
// module chunks = 0